/**
 * Who made the assignment. An engine assignment belongs to the run that made it.
 * A human override applies across runs, and only a person can negate.
 */
export enum EnrichmentSource {
  Engine = 'engine',
  HumanOverride = 'human_override',
}

/**
 * The dimensions a question is enriched on, one assignment table each.
 *
 * A graded measure is not a dimension of its own. Cognitive demand, for example,
 * is a `ScaleScore` on the `cognitive_demand` scale, and the scale's points give
 * each value its label.
 */
export enum EnrichmentDimension {
  Topic = 'topic',
  QuestionType = 'questionType',
  DirectiveVerb = 'directiveVerb',
  ScaleScore = 'scaleScore',
  Relationship = 'relationship',
}
